/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { createContext, useMemo, useState, FC } from 'react';
import { GetCurrentSurveySessionQuery } from '~lib/generatedGqlTypes';

type Survey = GetCurrentSurveySessionQuery['surveyTakingSession']['survey'];
type ActiveSurveyPage = GetCurrentSurveySessionQuery['surveyTakingSession']['currentPage'];

type SurveyContextType = {
  survey?: Survey;
  activePage?: ActiveSurveyPage;
  nextPage(): void;
  previousPage(): void;
  submitSurvey(): void;
};
export const SurveyContext = createContext<SurveyContextType>({
  survey: undefined,
  activePage: undefined,
  nextPage: () => {},
  previousPage: () => {},
  submitSurvey: () => {},
});

export type SurveyProviderProps = {
  children: React.ReactNode;
  survey: Survey;
  currentPage: GetCurrentSurveySessionQuery['surveyTakingSession']['currentPage'];
};

const SurveyProvider: FC<SurveyProviderProps> = ({ children, survey: initialSurvey, currentPage }) => {
  // Survey only rendering first page until we have information about who is responsible for providing next page.
  // When we get more information about how we will be acquiring other pages we will add those mechanisms here.
  const activePage = useMemo(() => currentPage, [currentPage]);
  // Survey currently holds error state, setSurvey will need to be called when upstream actions are hooked up.
  const [survey] = useState(initialSurvey);
  const nextPage = (): void => {
    console.log('Use this method to get the next page.  Pending decision about pagination');
  };
  const previousPage = (): void => {
    console.log('Use this method to get the previous page.  Pending decision about pagination');
  };
  const submitSurvey = (): void => {
    console.log('Use this method to submit the survey.');
  };

  return (
    <SurveyContext.Provider
      value={{
        survey,
        activePage,
        nextPage,
        previousPage,
        submitSurvey,
      }}
    >
      <>{children}</>
    </SurveyContext.Provider>
  );
};

export default SurveyProvider;
